var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['c-status-indicator', _vm.statusClass, 'qa-status-indicator']},[_c('div',{staticClass:"c-status-indicator__dot float-left"})])}
var staticRenderFns = []

export { render, staticRenderFns }